import React from "react"
import ReactDOM from "react-dom"

export default () => () => ({ App }) => {
  ReactDOM.render(<App />, document.getElementById(`root`))
}
